<template>
  <v-container fluid tag="section">
    <v-card class="rounded-lg elevation-0">
      <v-tabs v-model="tab" slider-color="primary">
        <v-tab v-has="'service-commission-settle'">咨询部提成</v-tab>
        <v-tab v-has="'project-commission-settle'">项目部提成</v-tab>
      </v-tabs>
    </v-card>
    <div class="my-3">
      <v-tabs-items v-model="tab">
        <v-tab-item class="grey lighten-4" v-has="'service-commission-settle'">
          <service-view></service-view>
        </v-tab-item>
        <v-tab-item class="grey lighten-4" v-has="'project-commission-settle'">
          <project-one></project-one>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
  import ServiceView from './components/Service.vue'
  import ProjectOne from './components/Project.vue'

  export default {
    name: 'SettleCommission',
    components: {
      ServiceView,
      ProjectOne
    },
    data() {
      return {
        tab: this.$_has('service-commission-settle') ? 0 : 1
      }
    },
    methods: {
    }
  }
</script>
